// QUANTITY SELECTOR
  document.addEventListener('DOMContentLoaded', function() {
  // Initialize all quantity selectors
  initializeQuantitySelectors();
});

function initializeQuantitySelectors() {
  // Handle both complementary products and main product selectors
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  quantitySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.qty-btn.minus, .quantity-button.quantity-minus');
    const plusBtn = selector.querySelector('.qty-btn.plus, .quantity-button.quantity-plus');
    const input = selector.querySelector('.qty-input, .quantity-input');
    
    if (minusBtn && plusBtn && input) {
      // Remove existing event listeners to prevent duplicates
      minusBtn.removeEventListener('click', handleQuantityChange);
      plusBtn.removeEventListener('click', handleQuantityChange);
      
      // Add event listeners
      minusBtn.addEventListener('click', () => handleQuantityChange(input, -1));
      plusBtn.addEventListener('click', () => handleQuantityChange(input, 1));
      
      // Handle direct input changes
      input.addEventListener('change', () => validateQuantityInput(input));
      input.addEventListener('blur', () => validateQuantityInput(input));
    }
  });
}

function handleQuantityChange(input, change) {
  const currentValue = parseInt(input.value) || 1;
  const minValue = parseInt(input.getAttribute('min')) || 1;
  const maxValue = parseInt(input.getAttribute('max')) || 99;
  
  let newValue = currentValue + change;
  
  // Ensure value stays within bounds
  newValue = Math.max(minValue, Math.min(maxValue, newValue));
  
  input.value = newValue;
  
  // Trigger change event for any other listeners
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function validateQuantityInput(input) {
  const value = parseInt(input.value);
  const minValue = parseInt(input.getAttribute('min')) || 1;
  const maxValue = parseInt(input.getAttribute('max')) || 99;
  
  if (isNaN(value) || value < minValue) {
    input.value = minValue;
  } else if (value > maxValue) {
    input.value = maxValue;
  }
}